  import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
  import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

  export const vsObjectName = "machineFundsTransferMethod";

  const url = "/api/machines/MachineFundsTransferMethod";

  export const machineFundsTransferMethodLookupConfig = simpleLookupConfig(
    vsLookupManagementServiceProviderName,
    {
      name: vsObjectName,
      nameSingular: "Funds Transfer Method",
      url,
    }
  );
